import { useMutation, useQuery, useQueryClient } from '@zg-rentals/react-query5';
import { user } from '@/src/lib/api/endpoints/user';
import type { SavedSearchCreateBody, SavedSearchItem } from '@/src/lib/api/endpoints/user';

import { savedSearchKeys } from './queryKeys';

export const useSavedSearches = (options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: savedSearchKeys.list(),
    queryFn: async () => {
      const response = await user.getSavedSearches();
      return response.data;
    },
    enabled: options?.enabled,
    staleTime: 30_000,
  });
};

export const useCreateSavedSearch = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: SavedSearchCreateBody) => user.createSavedSearch(body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: savedSearchKeys.all });
    },
  });
};

export const useUpdateSavedSearch = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: SavedSearchItem) => user.updateSavedSearch(body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: savedSearchKeys.all });
    },
  });
};

export const useDeleteSavedSearch = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (searchId: string) => user.deleteSavedSearch(searchId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: savedSearchKeys.all });
    },
  });
};
